/* eslint-disable no-param-reassign */
import { Store } from '@wonderlandlabs/looking-glass-engine';
import _ from 'lodash';
import { message } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';
import { categoryFetchQuery, categoryAddRecord, categoryFetchRecord } from '../../../store/models/Category';

import {
  eventToType, eventToString,
}
  from '../../../utils/eventExtraction';
import toMidnight from '../toMidnight';

dayjs.extend(utc);
function defaultValue(type) {
  switch (type) {
    case 'int':
      return 0;
      break;

    case 'integer':
      return 0;
      break;

    case 'long':
      return 0;
      break;

    case 'binary':
      return 1;
      break;

    case 'varchar':
      return '';
      break;

    case 'boolean':
      return 'true';
      break;

    default:
      return '';
  }
}

export default ({ pendingFieldTarget, pendingField, token }) => {
  const pfdStore = new Store({
    state: {},
    actions: {
      chooseComp({ actions }, event) {
        actions.setComp(eventToString(event));
      },
      chooseValue({ state, actions }, event) {
        const { pendingField } = state;
        actions.setValue(eventToType(event, pendingField.type));
      },
      chooseDateFromPicker({ state, actions }, date) {
        let dateString = date.toISOString();
        if (date.getTime() < new Date().getTime()) {
          dateString = toMidnight(date);
        }
        console.log('chooseDateFromPicker date:', date, 'toString:', dateString);
        actions.setDatePickerDate(dateString);
        actions.setValue(dateString);
      },
      reset({ state, actions }) {
        actions.setComp('=');
        actions.setValue(defaultValue(_.get(state, 'pendingField.type')));
      },
      fetchSample({ state, actions }) {
        const { pendingField, token } = state;
        if (!pendingField) {
          actions.setSample(false);
          return;
        }

        categoryFetchQuery(`SELECT topN(5, ${pendingField.toString()}) AS sample FROM media`, token)
          .then((sample) => {
            console.log('SAMPLE field result:', sample);
            actions.setSample(sample);
          })
          .catch((err) => {
            actions.setSample(false);
            console.log(pendingField.toString(true), 'sample query error: ', err);
          });
      },
    },
  });

  pfdStore
    .addProp('adder', {
      start: 'AND',
      type: 'string',
    })
    .addProp('pendingField', {
      start: pendingField,
    })
    .addProp('pendingFieldTarget', {
      start: pendingFieldTarget,
    })
    .addProp('sample', {
      start: false,
    })
    .addProp('datePickerDate', {
      start: new Date().toISOString(),
    })
    .addProp('value', {
      start: '',
    })
    .addProp('token', {
      start: token,
    })
    .addProp('comp', {
      start: '=',
      type: 'string',
    })
    .addProp('computedUrl', {
      type: 'string',
      start:
        '',
    });

  pfdStore.debugStream = {
    next(data) {
      return;
      console.log(
        '--debug queryTabStore for pfdStore ', data.state.queryName, ': change: ',
        _.get(data, 'change.info.action'),
        'resolved', _.get(data, 'change._resolved'),
        'id', _.get(data, 'change.id'),
        'data:', data,
      );
    },
  };
  pfdStore.start();
  pfdStore.actions.reset();

  return pfdStore;
};
